{
  "es": {
    "analytics": {
      "labels": {
        "click_seen_by": "Haz clic para más información",
        "click_shared_with": "Haz clic para ver qué clientes lo han visto",
        "deleted": "Eliminado",
        "deleted_item": "Este elemento se ha eliminado y ya no se puede pulsar",
        "noCustomers": "Todavía no hay clientes asignados a este nivel.",
        "noCustomersSeen": "Todavía ningún cliente lo ha visto.",
        "noCustomersUnseen": "Todos los clientes lo han visto.",
        "noUnitAccess": "Sin acceso a la unidad",
        "notSeen": "No visto ({number})",
        "seen": "Visto ({number})",
        "seenAt": "Visto el {date}",
        "seenBy": "Visto por",
        "seen_by_all": "Visto por todos. Haz clic para ver quién lo ha visto.",
        "sharedWithMultipleUnits": "Sin compartir con ninguna unidad en {level_name} | Compartido con 1 unidad en {level_name} | Compartido con {units_count} unidades en {level_name}",
        "sharedWithUnit": "Compartido con {unit_name}",
        "units": "Ninguna unidad | Una unidad | {count} unidades",
        "unseenOfTotal": "{unseen} de {total} todavía no lo han visto",
        "views": "Vistas",
        "viewsCount": "Ninguna vista | 1 vista | {count} vistas",
        "whoSeenAnnouncement": "Quién ha visto esta novedad"
      }
    }
  }
}
